import http from '@/http-common';

class KeysService {
  async validSerial(filial) {
    return http.get(`/keys/validSerial/${filial}`);
  }

  async confirmSerial(input) {
    return http.post('/keys/save', input);
  }

  async chegandoLiberacaoDias(input) {
    return http.post('/keys/checandoLiberacaoDias', input);
  }

  async confirmarPagamento(input) {
    return http.post('/keys/confirmarPagamento', input);
  }

  async efetuarPagamento(input) {
    return http.post('/keys/createPaymentVrPay', input);
  }

  async fillLiberacao(input) {
    return http.post('/keys/getLiberacaoUso', input);
  }

  async verificarSituacaoEmpresa(input) {
    return http.post('/keys/verificarSituacaoEmpresa/', input);
  }

  async validSerialProducao(filial) {
    return http.get(`/keys/validSerial/ordemProducao/${filial}`);
  }
}

export default new KeysService();
